module.exports = __webpack_public_path__ + "2e2e703b04224610644f1893851b7350.jpg";